<script>
  // Перенос PhotoCard из parts.tsx — карточка «фото + подпись + полка».
  // ВСЕ полки рисуются всегда, даже пустые: это держит одинаковую высоту
  // карточек в сетке. Полоса качества без редкости — нейтральная.
  import Photo from '../photo.svelte';
  export let src = '';
  export let title = '';
  export let sub = undefined;
  export let price = undefined;
  export let count = undefined;
  export let rarity = 0;
  export let active = false;
  export let flat = false;       // в React flat = карточка без onClick
  export let shotCls = '';
  export let icon = undefined;
</script>

<div class={'mn-card' + (active ? ' on' : '') + (flat ? ' flat' : '')} on:click>
  <div class={'rar mn-r' + (rarity || 0)}></div>
  {#if count != null}<div class="cnt">{count}</div>{/if}
  <Photo {src} alt={title} cls={shotCls} {icon} />
  <div class="cap">{title}</div>
  <div class="sub">{#if $$slots.sub}<slot name="sub" />{:else}{sub ?? ''}{/if}</div>
  <div class="foot">
    {#if $$slots.foot}<slot name="foot" />{:else if price != null}<span class="prc">{price}</span>{/if}
  </div>
</div>
